import { api } from '@/core/helpers/axiosHelper';
import { extractFilename } from '@/modules/board/composables/useBlobDownload';

export interface ExportResponse {
   data: string;
   fileName?: string;
}

export default {
   async get({
      squad_ids,
      from,
      to,
      team_id,
      slot_state_keys,
   }: {
      squad_ids: number[];
      from: string;
      to: string;
      team_id: number;
      slot_state_keys: string[];
   }): Promise<ExportResponse> {
      return await api
         .get('/export/extended', {
            params: {
               squad_ids,
               from,
               to,
               team_id,
               slot_state_keys,
            },
         })
         .then((response) => ({
            data: response.data,
            fileName: extractFilename(response.headers?.['content-disposition']),
         }));
   },
   async post(body: { squad_ids: number[]; from: string; to: string; type: string; location_key: string; department_key: string }): Promise<ExportResponse> {
      return await api.post('/export/light', body).then((response) => ({
         data: response.data,
         fileName: extractFilename(response.headers?.['content-disposition']),
      }));
   },
   async postNeeds(body: { squad_ids: number[]; from: string; to: string; board_id: number }): Promise<ExportResponse> {
      return await api.post('/export/board-needs', body).then((response) => ({
         data: response.data,
         fileName: extractFilename(response.headers?.['content-disposition']),
      }));
   },
   async postSlots(body: { squad_ids: number[]; from: string; to: string; board_id: number; slot_state_ids: number[] }): Promise<ExportResponse> {
      return await api.post('/export/board-slots', body).then((response) => ({
         data: response.data,
         fileName: extractFilename(response.headers?.['content-disposition']),
      }));
   },
   async poolStructure(body: { pool_id: number }): Promise<ExportResponse> {
      return await api.post('/export/pool-structure', body).then((response) => ({
         data: response.data,
         fileName: extractFilename(response.headers?.['content-disposition']),
      }));
   },
};
